// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  box-sizing:border-box;
  font-family:'Outfit',sans-serif;
}

.trainingentryform_overlay{
  position:fixed;
  inset:0;
  background:rgba(15,23,42,.55);
  backdrop-filter:blur(6px);
  display:flex;
  justify-content:center;
  align-items:center;
  z-index:9999;
  padding:20px;
}

.trainingentryform_modal{
  width:75%;
  max-width:950px;
  height:85vh;
  overflow-y:auto;
  background:#fff;
  border-radius:18px;
  box-shadow:0 25px 70px rgba(0,0,0,.18);
}

.trainingentryform_header{
  display:flex;
  justify-content:space-between;
  align-items:center;
  padding:18px 25px;
  border-bottom:1px solid #edf2f7;
  background:#fff;
  position:sticky;
  top:0;
  z-index:10;
}

.trainingentryform_title{
  font-size:24px;
  font-weight:700;
  color:#111827;
}

.trainingentryform_close_button{
  width:40px;
  height:40px;
  border:none;
  border-radius:50%;
  background:#f3f4f6;
  cursor:pointer;
}

.trainingentryform_close_button:hover{
  background:#ef4444;
  color:#fff;
}

.trainingentryform_grid{
  padding:25px;
  display:grid;
  grid-template-columns:repeat(3,1fr);
  gap:20px;
}

.trainingentryform_field{
  display:flex;
  flex-direction:column;
}

.trainingentryform_label{
  margin-bottom:8px;
  font-size:14px;
  font-weight:600;
  color:#374151;
}

.trainingentryform_input,
.trainingentryform_select{
  height:44px;
  border:1px solid #dbe2ea;
  border-radius:10px;
  padding:0 12px;
  background:#fafafa;
}

.trainingentryform_input:focus,
.trainingentryform_select:focus{
  outline:none;
  border-color:#2563eb;
  box-shadow:0 0 0 4px rgba(37,99,235,.08);
}

.trainingentryform_remarks_wrapper{
  padding:0 25px 20px;
}

.trainingentryform_textarea{
  width:100%;
  height:120px;
  border:1px solid #dbe2ea;
  border-radius:10px;
  padding:12px;
  resize:none;
}

.trainingentryform_upload_grid{
  padding:0 25px 25px;
  display:grid;
  grid-template-columns:repeat(3,1fr);
  gap:16px;
}

.trainingentryform_upload_card{
  border:2px dashed #dbe2ea;
  border-radius:14px;
  background:#fafafa;
  min-height:90px;
  display:flex;
  justify-content:center;
  align-items:center;
  transition:.3s;
}

.trainingentryform_upload_card:hover{
  border-color:#2563eb;
  background:#f8fbff;
}

.trainingentryform_hidden_input{
  display:none;
}

.trainingentryform_upload_label{
  width:100%;
  height:100%;
  display:flex;
  justify-content:center;
  align-items:center;
  cursor:pointer;
  color:#2563eb;
  font-weight:600;
}

.trainingentryform_footer{
  display:flex;
  justify-content:flex-end;
  gap:12px;
  padding:20px 25px;
  border-top:1px solid #edf2f7;
}

.trainingentryform_cancel_button{
  min-width:120px;
  height:42px;
  border:none;
  border-radius:10px;
  background:#e5e7eb;
  cursor:pointer;
}

.trainingentryform_save_button{
  min-width:120px;
  height:42px;
  border:none;
  border-radius:10px;
  background:#2563eb;
  color:#fff;
  cursor:pointer;
}

@media(max-width:768px){

  .trainingentryform_modal{
    width:95%;
    height:92vh;
  }

  .trainingentryform_grid{
    grid-template-columns:1fr;
  }

  .trainingentryform_upload_grid{
    grid-template-columns:1fr;
  }

}`, "",{"version":3,"sources":["webpack://./src/styles/newtrainingform.css"],"names":[],"mappings":"AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,OAAO;EACP,6BAA6B;EAC7B,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,KAAK;EACL,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mCAAmC;EACnC,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mCAAmC;EACnC,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;;AAEA;;EAEE;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;AAEF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap');\n\n*{\n  box-sizing:border-box;\n  font-family:'Outfit',sans-serif;\n}\n\n.trainingentryform_overlay{\n  position:fixed;\n  inset:0;\n  background:rgba(15,23,42,.55);\n  backdrop-filter:blur(6px);\n  display:flex;\n  justify-content:center;\n  align-items:center;\n  z-index:9999;\n  padding:20px;\n}\n\n.trainingentryform_modal{\n  width:75%;\n  max-width:950px;\n  height:85vh;\n  overflow-y:auto;\n  background:#fff;\n  border-radius:18px;\n  box-shadow:0 25px 70px rgba(0,0,0,.18);\n}\n\n.trainingentryform_header{\n  display:flex;\n  justify-content:space-between;\n  align-items:center;\n  padding:18px 25px;\n  border-bottom:1px solid #edf2f7;\n  background:#fff;\n  position:sticky;\n  top:0;\n  z-index:10;\n}\n\n.trainingentryform_title{\n  font-size:24px;\n  font-weight:700;\n  color:#111827;\n}\n\n.trainingentryform_close_button{\n  width:40px;\n  height:40px;\n  border:none;\n  border-radius:50%;\n  background:#f3f4f6;\n  cursor:pointer;\n}\n\n.trainingentryform_close_button:hover{\n  background:#ef4444;\n  color:#fff;\n}\n\n.trainingentryform_grid{\n  padding:25px;\n  display:grid;\n  grid-template-columns:repeat(3,1fr);\n  gap:20px;\n}\n\n.trainingentryform_field{\n  display:flex;\n  flex-direction:column;\n}\n\n.trainingentryform_label{\n  margin-bottom:8px;\n  font-size:14px;\n  font-weight:600;\n  color:#374151;\n}\n\n.trainingentryform_input,\n.trainingentryform_select{\n  height:44px;\n  border:1px solid #dbe2ea;\n  border-radius:10px;\n  padding:0 12px;\n  background:#fafafa;\n}\n\n.trainingentryform_input:focus,\n.trainingentryform_select:focus{\n  outline:none;\n  border-color:#2563eb;\n  box-shadow:0 0 0 4px rgba(37,99,235,.08);\n}\n\n.trainingentryform_remarks_wrapper{\n  padding:0 25px 20px;\n}\n\n.trainingentryform_textarea{\n  width:100%;\n  height:120px;\n  border:1px solid #dbe2ea;\n  border-radius:10px;\n  padding:12px;\n  resize:none;\n}\n\n.trainingentryform_upload_grid{\n  padding:0 25px 25px;\n  display:grid;\n  grid-template-columns:repeat(3,1fr);\n  gap:16px;\n}\n\n.trainingentryform_upload_card{\n  border:2px dashed #dbe2ea;\n  border-radius:14px;\n  background:#fafafa;\n  min-height:90px;\n  display:flex;\n  justify-content:center;\n  align-items:center;\n  transition:.3s;\n}\n\n.trainingentryform_upload_card:hover{\n  border-color:#2563eb;\n  background:#f8fbff;\n}\n\n.trainingentryform_hidden_input{\n  display:none;\n}\n\n.trainingentryform_upload_label{\n  width:100%;\n  height:100%;\n  display:flex;\n  justify-content:center;\n  align-items:center;\n  cursor:pointer;\n  color:#2563eb;\n  font-weight:600;\n}\n\n.trainingentryform_footer{\n  display:flex;\n  justify-content:flex-end;\n  gap:12px;\n  padding:20px 25px;\n  border-top:1px solid #edf2f7;\n}\n\n.trainingentryform_cancel_button{\n  min-width:120px;\n  height:42px;\n  border:none;\n  border-radius:10px;\n  background:#e5e7eb;\n  cursor:pointer;\n}\n\n.trainingentryform_save_button{\n  min-width:120px;\n  height:42px;\n  border:none;\n  border-radius:10px;\n  background:#2563eb;\n  color:#fff;\n  cursor:pointer;\n}\n\n@media(max-width:768px){\n\n  .trainingentryform_modal{\n    width:95%;\n    height:92vh;\n  }\n\n  .trainingentryform_grid{\n    grid-template-columns:1fr;\n  }\n\n  .trainingentryform_upload_grid{\n    grid-template-columns:1fr;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
